import styled from 'styled-components';
import { colors } from '@/globalStyles';

export const ItemsContainer = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: start;
  align-items: center;
  position: relative;
  z-index: 1;

  .MuiAccordionSummary-root:before {
    content: '';
    height: 2px;
    background-color: #fff !important;
    z-index: 999;
    opacity: 1;
    position: absolute;
    left: 0;
    top: -1px;
    right: 0;
  }

  .MuiTypography-root,
  .MuiTypography-body1 {
    font-weight: 500 !important;
    font-size: 18px;
    font-family: 'IBMPlexSans' !important;
  }
`;

export const InsertContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  justify-content: start;
  align-items: center;
  z-index: 9999;
  position: absolute;
  right: 0;
  top: 0;
  background-color: #ffffff;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-gap: ${props => props.gridGap || '10px'};
  grid-template-columns: ${props => props.gridTemplateColumns || 'max-content'};
  grid-template-rows: ${props => props.gridTemplateRows || 'max-content'};
  grid-auto-rows: ${props => props.gridTemplateRows || 'max-content'};
  width: 100%;
`;

export const Label = styled.div`
  font-size: 14px;
  font-family: Lato;
  font-weight: 400;
  line-height: normal;
  color: ${props => props.color || colors.black};
`;

export const NotExpandable = styled.div`
  background-color: #ffffff;
  padding: 16px;
  justify-content: left;
  align-items: center;
  width: 100%;
  display: ${props => (props.isVisible ? 'flex' : 'none')};
  flex-direction: column;
`;

export const Icon = styled.img`
  width: 30px;
  height: 30px;
`;

export const Icon24 = styled.img`
  width: 24px;
  height: 24px;
`;

export const Icon16 = styled.img`
  width: 16px;
  height: 16px;
`;

export const GroupsLabel = styled.div`
  height: 100%;
  width: 100%;
  text-align: center;
  vertical-align: center;
  display: grid;
  align-items: center;
  font-size: 12px;
  color: #000000;
`;

export const GroupItem = styled.div`
  width: 100%;
  height: 40px;
  display: grid;
  align-items: center;
  justify-content: center;
`;

export const HeaderContainer = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const TitleLabel = styled.div`
  font-size: 24px;
  font-weight: 500;
  font-family: 'IBMPlexSans';
`;

export const ToggleButton = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 2px solid;
  border-bottom-color: ${props => (props.selected ? colors.primary : 'transparent')};
  cursor: pointer;
  :hover {
    * {
      fill: #007e83;
    }
  }
`;

export const TextSelectButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  height: 49px;
  max-height: 49px;
  font-size: 14px;
  font-family: IBMPlexSans;
  font-weight: 400;
  border-radius: 4px;
  background-color: #f4f4f4;
  overflow: hidden;
  padding: 10px 20px;
  cursor: pointer;
  width: 100%;

  div {
    display: flex;
    height: 100%;
    align-items: center;
  }
`;

export const SelectionItems = styled.div`
  display: grid;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding-top: 20px;
`;

export const SelectionItem = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 5px 20px;
  color: ${props => (props.selected ? '#a6a6a6' : '#202020')};
  &:hover {
    background-color: ${props => (props.selected ? 'unset' : '#f4f4f4')};
  }
`;

export const OptionButtonStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 49px;
  max-height: 49px;
  font-weight: 400;
  border-radius: 4px;
  background-color: #f4f4f4;
  overflow: hidden;
  cursor: pointer;
  color: ${colors.nero} !important;

  &:hover {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
    color: ${colors.primary} !important;
  }
  &:active {
    box-shadow: none;
    color: ${colors.primary} !important;
  }
  &.disabled {
    box-shadow: none;
  }
`;
